export const ROOT_ROUTE = "/";
export const SIGN_IN_ROUTE = "/sign-in";
export const SIGN_UP_ROUTE = "/sign-up";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
export const RESTORE_PASSWORD_ROUTE = "/restore-password";
export const ANALYTICS_ROUTE = "/analytics";
export const REPORTS_ROUTE = "/reports";
